import { render, staticRenderFns } from "./AddUniversityAccount.vue?vue&type=template&id=c2fa6822&scoped=true&"
import script from "./AddUniversityAccount.vue?vue&type=script&lang=js&"
export * from "./AddUniversityAccount.vue?vue&type=script&lang=js&"
import style0 from "./AddUniversityAccount.vue?vue&type=style&index=0&id=c2fa6822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fa6822",
  null
  
)

export default component.exports